import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const Cookies = () => {
  return (
    <div className="bg-zinc-950 text-white min-h-screen">
      <div className="container mx-auto max-w-4xl px-4 py-16">
        <Link 
          to="/" 
          className="inline-flex items-center text-amber-500 hover:text-amber-400 mb-8"
        >
          <ArrowLeft className="mr-2" size={20} />
          Torna alla Home
        </Link>

        <h1 className="text-4xl md:text-5xl font-serif font-bold mb-8">
          Cookie <span className="text-amber-500">Policy</span>
        </h1>

        <div className="space-y-8 text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">1. Cosa sono i Cookie</h2>
            <p>
              I cookie sono piccoli file di testo che i siti visitati dall'utente inviano al suo terminale (solitamente al browser), dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla successiva visita del medesimo utente.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">2. Tipologie di Cookie Utilizzati</h2>
            
            <h3 className="text-xl font-semibold text-amber-500 mt-4 mb-2">Cookie Tecnici</h3>
            <p>
              Sono cookie necessari per il corretto funzionamento del sito web. Permettono la navigazione e l'utilizzo delle funzionalità di base. Questi cookie non raccolgono informazioni personali.
            </p>

            <h3 className="text-xl font-semibold text-amber-500 mt-4 mb-2">Cookie Analitici</h3>
            <p>
              Sono cookie che raccolgono informazioni in forma aggregata sul numero degli utenti e su come questi visitano il sito. Utilizziamo questi dati per migliorare l'esperienza di navigazione.
            </p>

            <h3 className="text-xl font-semibold text-amber-500 mt-4 mb-2">Cookie di Terze Parti</h3>
            <p>
              Il sito potrebbe contenere collegamenti ad altri siti Web che dispongono di una propria informativa sulla privacy. Queste policy possono essere diverse da quella adottata da Roger'S Club Barberia.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">3. Cookie di Terze Parti Presenti sul Sito</h2>
            <ul className="list-disc list-inside mt-2 space-y-2">
              <li>
                <strong className="text-white">Google Maps:</strong> Utilizziamo Google Maps per mostrare la posizione della nostra attività. Google potrebbe raccogliere dati secondo la propria privacy policy.
              </li>
              <li>
                <strong className="text-white">Google Analytics:</strong> Per analisi statistiche anonime sul traffico del sito.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">4. Come Gestire i Cookie</h2>
            <p>
              L'utente può gestire le preferenze relative ai cookie direttamente all'interno del proprio browser ed impedire che terze parti possano installarne. Tramite le preferenze del browser è inoltre possibile eliminare i cookie installati in passato.
            </p>
            <p className="mt-4">
              Di seguito i link alle istruzioni per la gestione dei cookie nei principali browser:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-amber-500 hover:text-amber-400">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop" target="_blank" rel="noopener noreferrer" className="text-amber-500 hover:text-amber-400">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-amber-500 hover:text-amber-400">Safari</a></li>
              <li><a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-amber-500 hover:text-amber-400">Microsoft Edge</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">5. Conseguenze della Disabilitazione dei Cookie</h2>
            <p>
              La disabilitazione dei cookie potrebbe limitare la possibilità di usare il sito e impedire di beneficiare in pieno delle funzionalità e dei servizi presenti. Per decidere quali accettare e quali rifiutare, è illustrata di seguito una descrizione dei cookie utilizzati su questo sito.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">6. Titolare del Trattamento</h2>
            <p>
              Roger'S Club Barberia<br />
              Via Tanzini, 41 - 50065 Pontassieve (FI)<br />
              P.IVA: 07183440481<br />
              Tel: +39 331 885 7252
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">7. Aggiornamenti</h2>
            <p>
              La presente Cookie Policy può subire modifiche nel tempo – anche connesse all'eventuale entrata in vigore di nuove normative di settore, all'aggiornamento o erogazione di nuovi servizi ovvero ad intervenute innovazioni tecnologiche – per cui l'utente è invitato a consultare periodicamente questa pagina.
            </p>
          </section>

          <section className="border-t border-zinc-800 pt-8">
            <p className="text-sm text-gray-500">
              Ultimo aggiornamento: Febbraio 2026
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
